import { GetterTree } from 'vuex';
import { GeolocationState, RootState } from '../types';

export const getters: GetterTree<GeolocationState, RootState> = {
	getGeolocationResults(state): GeolocationSearchResponse | null {
		return state.geolocationResults;
	},

	getGeolocationPayload(state): GeolocationPayload {
		return state.geolocationPayload;
	},

	getCountry(state): string | string[] {
		return state.country;
	},

	getGeolocationPermission(state): string {
		return state.geolocationPermission;
	},

	getShowDistance(state): boolean {
		return state.showDistance;
	}
};